// TelcoTrack - Payment Badge Component
// Unified badge for work-report payment status (unpaid / invoiced / mixed aggregate).

import { Component, Input } from '@angular/core';
import {
  workReportAggregatePaymentBadgeClass,
  workReportAggregatePaymentBadgeLabel,
  workReportDisplayLinePaymentUniform,
  workReportRowPaymentBadgeClass,
  workReportRowPaymentLabel,
} from '../../../utils/work-report.utils';

@Component({
  selector: 'app-payment-badge',
  template: `<span [ngClass]="badgeClass">{{ label }}</span>`,
  styleUrls: ['../../../../features/work-report/work-report-payment-badges.scss'],
})
export class PaymentBadgeComponent {
  /** Single row payment status from API. */
  @Input() paymentStatus?: string | null;
  /** Aggregate uniform state for grouped display lines. */
  @Input() uniform?: ReturnType<typeof workReportDisplayLinePaymentUniform>;

  get badgeClass(): string {
    if (this.uniform !== undefined) {
      return workReportAggregatePaymentBadgeClass(this.uniform);
    }
    return workReportRowPaymentBadgeClass(this.paymentStatus);
  }

  get label(): string {
    if (this.uniform !== undefined) {
      return workReportAggregatePaymentBadgeLabel(this.uniform);
    }
    return workReportRowPaymentLabel(this.paymentStatus);
  }
}
